import React from "react";

const AssessmentOptionList = ({ items, onEdit }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover">
					<tbody>
						{list.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells">
									<div className="todo-check pull-left">{index + 1}</div>
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
								</td>

								<td className="view-message">
									Value: <strong title="Option's value">{item.value}</strong>
								</td>

								<td className="view-message text-right">
									<button
										title="Update"
										onClick={() => onEdit(item)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">edit</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{list.length < 1 && (
					<div className="text-center m-t-10 m-b-10">
						<h5 className="text-danger">No Assessment Option is added yet!</h5>
					</div>
				)}
			</div>
		</div>
	);
};

export default AssessmentOptionList;
